import './HomePage.scss'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { find } from 'lodash'

import AdArea from '../../components/AdArea'
import Meta from '../../components/Meta'
import CoverContainer from './CoverContainer'
import CurationContainer from './CurationContainer'

import { AdAreaHeight } from '../../constants/enums'
import { adSpots } from '../../advertisement'

const metaContents: {
  [key: string]: {
    title: string
    description: string
    keywords: string[]
  }
} = {
  en: {
    title: 'OnDemandChina - Chinese Drama, Movies & TV Shows - Watch HD content for free',
    description:
      'Watch Chinese Drama, Movie and Variety in HD for Free! Watch more Korean TV Shows & Movie, Japanese dramas in Chinese. Visit now!',
    keywords: ['Movie', 'Drama', 'Documentary', 'Variety', 'News', 'Chinese Content', 'Online Free Watch'],
  },
  'zh-Hans': {
    title: 'OnDemandChina - 北美海外华人首选视频网站 - 正版高清在线播放',
    description:
      '免费观看高清中国电视剧、电影、综艺等多种节目，更有高分韩日剧在线看。ODC影视为北美华人提供高清免费正版的影视内容，每日更新，优质视频尽在OnDemandChina。',
    keywords: [
      'OnDemandChina',
      'ODC影视',
      '海外华人',
      '纪录片',
      '综艺',
      '新闻',
      '线上看',
      '免费在线观看',
      '视频网站',
      '高清视频',
      '韩剧',
      '日剧',
      '韩国电影',
      '美国怎么看电影',
      '美国怎么看电视剧',
      '海外在线观看',
      '电视剧电影在线看',
    ],
  },
  'zh-Hant': {
    title: 'OnDemandChina - 北美海外華人首選視頻網站 - 正版高清在線播放',
    description:
      '免費觀看高清中國電視劇、電影、綜藝等多種節目，更有高分韓日劇在線看。ODC影視為北美華人提供高清免費正版的影視內容，每日更新，優質視頻盡在OnDemandChina。',
    keywords: [
      'OnDemandChina',
      'ODC影視',
      '海外華人',
      '紀錄片',
      '綜藝',
      '新聞',
      '線上看',
      '免費在線觀看',
      '視頻網站',
      '高清視頻',
      '韓劇',
      '日劇',
      '韓國電影',
      '美國怎麼看電影',
      '美國怎麼看電視劇',
      '海外在線觀看',
      '電視劇電影在線看',
    ],
  },
}

export default function HomePage() {
  const { t } = useTranslation()
  const { i18n } = useTranslation()

  const articleBottomAdSpot = find(adSpots, { name: 'ODC_ARTICLE_BOTTOM' })!
  const { title, description, keywords } = metaContents[i18n.language]

  return (
    <div className="HomePage">
      <Meta
        title={title}
        description={description}
        keywords={keywords}
        imageUrl="https://www.ondemandchina.com/images/home-meta-image.jpg"
        uri={`/${i18n.language}`}
      />
      <h1 className="screen-reader-text">Ondemand China Home</h1>
      <h2 className="screen-reader-text">{t('home.h2')}</h2>
      <CoverContainer />
      <CurationContainer />
      <AdArea
        className="HomePage__bottomAd"
        adSpotId={articleBottomAdSpot.spotId}
        height={AdAreaHeight.ARTICLE_BOTTOM}
      />
    </div>
  )
}
